// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"PublishAnnouncement--next-sr-only--1wUspAa","footerButtonsContainer":"PublishAnnouncement--footerButtonsContainer--14Viy7g"};